import React from 'react';
import './AuthInputField.css';

export function AuthInputField({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  icon: Icon,
  required = false,
  autoComplete,
}) {
  return (
    <div className="auth-form-field">
      <label className="auth-form-label" htmlFor={id}>
        {label}
      </label>
      <div className="auth-input-wrapper">
        {Icon && <Icon size={16} className="auth-input-icon" />}
        <input
          id={id}
          type={type}
          className="auth-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
        />
      </div>
    </div>
  );
}
